import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CouponCompanyUsedModel } from '../../../../../model/builk/coupon/project-coupon.model';

@Component({
  selector: 'app-company-used',
  templateUrl: './company-used.component.html',
  styleUrls: ['./company-used.component.scss']
})
export class CompanyUsedModalComponent {
  @ViewChild("template") template: TemplateRef<any>;

  modalRef: BsModalRef;

  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();

  // array
  companyUsedList: Array<CouponCompanyUsedModel> = [];

  constructor(
    private modalService: BsModalService,
  ) { }

  openModal(value: Array<CouponCompanyUsedModel>): void {
    this.companyUsedList = [];
    this.companyUsedList = value;
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  close(): void {
    this.modalRef.hide();
  }
}
